import React, {Component} from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import classnames from "classnames";
import GridHeadlineText from "./component/gridHeadlineText/gridHeadlineText";
import Row from "./../../../../components/row/row";
import gridSectionStyles from "./gridSection.module.pcss";

const GridSection = ({featureSectionHeadline, className, columns, features}) => {
  return (
    <Row displayFlex={false} rowWrapperClassName={classnames(gridSectionStyles.gridSection, className)}>
      <Markdown source={featureSectionHeadline} />
      <GridHeadlineText columns={columns} features={features} />
    </Row>
  )
};

GridSection.propTypes = {
  className: PropTypes.string,
  featureSectionHeadline: PropTypes.string.isRequired,
  columns: PropTypes.number.isRequired,
  features: PropTypes.array.isRequired
};

export default GridSection;


// WEBPACK FOOTER //
// ./src/templates/landing/components/gridSection/gridSection.js